// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchbar-row {
  display: flex;
  align-items: center;
  padding: 5px 4px 0;
  justify-content: space-between;
  background-color: #fff;
}

ion-searchbar {
  border-radius: 4px;
  height: 100%;
}

.searchbar-grid ion-grid {
  --ion-item-background: var(--ion-color-light) !important;
  padding-top: 0;
}

ion-searchbar.md,
ion-searchbar.ios {
  --clear-button-color: var(--ion-color-light) !important;
}

ion-button {
  height: 42px;
}

ion-button.ios {
  height: 42px;
}
@media screen and (max-width: 768px) {
  ion-button.ios {
    height: 36px;
  }
}

ion-thumbnail {
  border: 2px solid var(--ion-color-dark);
  border-radius: 5px;
}

.items-count {
  position: absolute;
  z-index: 999;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1rem;
  right: 150%;
  font-weight: bold;
  color: var(--ion-color-primary-contrast);
}
@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
    .items-count {
      top: 50%;
    }
  }
}
@media screen and (max-width: 768px) {
  .items-count {
    top: 50%;
  }
}

ion-searchbar[font*=secondary] {
  font-family: var(--font-secondary);
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/searchbar/searchbar.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;EACA,sBAAA;AACF;;AAEA;EAEE,kBAAA;EACA,YAAA;AAAF;;AAGA;EACE,wDAAA;EACA,cAAA;AAAF;;AAGA;;EAEE,uDAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,YAAA;AAAF;AACE;EAFF;IAGI,YAAA;EAEF;AACF;;AACA;EACE,uCAAA;EACA,kBAAA;AAEF;;AAAA;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,wCAAA;AAGF;AADE;EACE;IAXJ;MAYM,QAAA;IAIF;EACF;AACF;AAFE;EAhBF;IAiBI,QAAA;EAKF;AACF;;AADE;EACE,kCAAA;AAIJ","sourcesContent":[".searchbar-row {\n  display: flex;\n  align-items: center;\n  padding: 5px 4px 0;\n  justify-content: space-between;\n  background-color: #fff;\n}\n\nion-searchbar {\n  //border: 1px solid var(--ion-color-secondary);\n  border-radius: 4px;\n  height: 100%;\n}\n\n.searchbar-grid ion-grid {\n  --ion-item-background: var(--ion-color-light) !important;\n  padding-top: 0;\n}\n\nion-searchbar.md,\nion-searchbar.ios {\n  --clear-button-color: var(--ion-color-light) !important;\n}\n\nion-button {\n  height: 42px;\n}\n\nion-button.ios {\n  height: 42px;\n  @media screen and (max-width:768px) {\n    height: 36px;\n  }\n}\n\nion-thumbnail {\n  border: 2px solid var(--ion-color-dark);\n  border-radius: 5px;\n}\n.items-count {\n  position: absolute;\n  z-index: 999;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 1rem;\n  right: 150%;\n  font-weight: bold;\n  color: var(--ion-color-primary-contrast);\n\n  @media not all and (min-resolution:.001dpcm) {\n    @supports (-webkit-appearance:none) {\n      top: 50%;\n    }\n  }\n\n  @media screen and (max-width:768px) {\n    top: 50%;\n  }\n}\n\nion-searchbar {\n  &[font*='secondary'] {\n    font-family: var(--font-secondary);\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
